import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgContactFilled = (props) => /* @__PURE__ */ _jsx("svg", {
	height: 16,
	width: 16,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "m16 14.96v-8.208a2.03 2.03 0 0 0 -2.048-2.048h-2.528v-.656c0-.363-.093-.701-.28-1.016a2.117 2.117 0 0 0 -.752-.752 1.957 1.957 0 0 0 -1.016-.28h-7.328a2.053 2.053 0 0 0 -2.048 2.048v8.208l2.928-1.872h1.648v.656c0 .363.093.701.28 1.016s.437.565.752.752.653.28 1.016.28h6.448zm-14.96-4.608v-6.304a.97.97 0 0 1 .296-.712.97.97 0 0 1 .712-.296h7.328a.97.97 0 0 1 .712.296.97.97 0 0 1 .296.712v.656h-3.76c-.363 0-.701.09-1.016.272a2.053 2.053 0 0 0 -1.032 1.776v2.592h-1.952z",
		fill: "#2b2b2b"
	})
});
export default SvgContactFilled;
